import React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

const COMPANY_TYPES = [
  { value: 'landscaping', label: 'Landscaping Company' },
  { value: 'construction', label: 'Construction Company' },
  { value: 'tree_company', label: 'Tree Company' },
  { value: 'debris_hauling', label: 'Debris Hauling Company' },
  { value: 'equipment_rental', label: 'Equipment Rental Company' },
];

function CompanyInfoStep({ data, errors, onChange }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  return (
    <div className="company-info-step">
      <h5 className="mb-4">Company Information</h5>

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Form.Group controlId="company_name">
            <Form.Label>Company Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="company_name"
              value={data.company_name}
              onChange={handleChange}
              isInvalid={!!errors.company_name}
              placeholder="Enter company name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.company_name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group controlId="company_type">
            <Form.Label>Company Type <span className="text-danger">*</span></Form.Label>
            <Form.Select
              name="company_type"
              value={data.company_type}
              onChange={handleChange}
              isInvalid={!!errors.company_type}
            >
              <option value="">Select company type</option>
              {COMPANY_TYPES.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.company_type}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Form.Group controlId="website">
            <Form.Label>Website (Optional)</Form.Label>
            <Form.Control
              type="url"
              name="website"
              value={data.website}
              onChange={handleChange}
              placeholder="https://www.example.com"
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group controlId="year_established">
            <Form.Label>Year Established (Optional)</Form.Label>
            <Form.Control
              type="number"
              name="year_established"
              value={data.year_established}
              onChange={handleChange}
              min="1800"
              max={new Date().getFullYear()}
              placeholder="YYYY"
            />
          </Form.Group>
        </Col>
      </Row>

      <hr className="my-4" />
      <h5 className="mb-4">Company Address</h5>

      <Row className="mb-3">
        <Col xs={12}>
          <Form.Group controlId="address">
            <Form.Label>Street Address <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="address"
              value={data.address}
              onChange={handleChange}
              isInvalid={!!errors.address}
              placeholder="Enter street address"
            />
            <Form.Control.Feedback type="invalid">
              {errors.address}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={5}>
          <Form.Group controlId="city">
            <Form.Label>City <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="city"
              value={data.city}
              onChange={handleChange}
              isInvalid={!!errors.city}
              placeholder="Enter city"
            />
            <Form.Control.Feedback type="invalid">
              {errors.city}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12} md={4}>
          <Form.Group controlId="state">
            <Form.Label>State <span className="text-danger">*</span></Form.Label>
            <Form.Select
              name="state"
              value={data.state}
              onChange={handleChange}
              isInvalid={!!errors.state}
            >
              <option value="">Select state</option>
              {US_STATES.map((state) => (
                <option key={state.code} value={state.code}>
                  {state.name}
                </option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.state}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12} md={3}>
          <Form.Group controlId="zip_code">
            <Form.Label>ZIP Code <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="zip_code"
              value={data.zip_code}
              onChange={handleChange}
              isInvalid={!!errors.zip_code}
              placeholder="Enter ZIP"
            />
            <Form.Control.Feedback type="invalid">
              {errors.zip_code}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>

      <hr className="my-4" />
      <h5 className="mb-4">Primary Contact</h5>

      <Row className="mb-3">
        <Col xs={12} md={4}>
          <Form.Group controlId="contact_first_name">
            <Form.Label>First Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="contact_first_name"
              value={data.contact_first_name}
              onChange={handleChange}
              isInvalid={!!errors.contact_first_name}
              placeholder="Enter first name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.contact_first_name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12} md={4}>
          <Form.Group controlId="contact_last_name">
            <Form.Label>Last Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              name="contact_last_name"
              value={data.contact_last_name}
              onChange={handleChange}
              isInvalid={!!errors.contact_last_name}
              placeholder="Enter last name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.contact_last_name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12} md={4}>
          <Form.Group controlId="contact_title">
            <Form.Label>Title (Optional)</Form.Label>
            <Form.Control
              type="text"
              name="contact_title"
              value={data.contact_title}
              onChange={handleChange}
              placeholder="e.g., Property Manager"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Form.Group controlId="contact_email">
            <Form.Label>Email Address <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="email"
              name="contact_email"
              value={data.contact_email}
              onChange={handleChange}
              isInvalid={!!errors.contact_email}
              placeholder="Enter email address"
            />
            <Form.Control.Feedback type="invalid">
              {errors.contact_email}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Form.Group controlId="contact_phone">
            <Form.Label>Phone Number <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="tel"
              name="contact_phone"
              value={data.contact_phone}
              onChange={handleChange}
              isInvalid={!!errors.contact_phone}
              placeholder="Enter phone number"
            />
            <Form.Control.Feedback type="invalid">
              {errors.contact_phone}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
}

export default CompanyInfoStep;
